document.addEventListener('DOMContentLoaded', function () {

  const sections = document.querySelectorAll('.collection-description-section');

  if (!sections.length) return;

  sections.forEach((section) => {

    const content = section.querySelector('[data-description-content]');
    const button = section.querySelector('[data-description-toggle]');

    if (!content || !button) return;

    // Hide button if content is too small
    setTimeout(() => {
      if (content.scrollHeight <= content.clientHeight + 10) {
        button.style.display = 'none';
      }
    }, 100);

    button.addEventListener('click', function () {

      content.classList.toggle('expanded');

      if (content.classList.contains('expanded')) {
        button.textContent = 'Discontinue Reading';
      } else {
        button.textContent = 'Continue Reading';
      }

    });

  });

});